import styled, { css } from "styled-components";

export const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || "row"};
  justify-content: ${({ justify }) => justify || "center"};
  align-items: ${({ align }) => align || "center"};
  width: ${({ width }) => (width != undefined ? width : "100%")};
  height: ${({ height }) => (height != undefined ? height : "100%")};
`;

export const ComponentWrapper = styled.div`
  padding-bottom: 20px;
`;

export const CardWrapper = styled.div`
  margin-top: 29px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: ${({ align }) => align || "center"};
  font-size: ${({ fontSize }) => (fontSize != undefined ? fontSize : "12px")};
  font-family: Roboto;
  width: ${({ width }) => (width != undefined ? width : "100%")};
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-top: ${({ marginTop }) => (marginTop != undefined ? marginTop : 0)}px;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom != undefined ? marginBottom : 10}px;
  height: ${({ height }) => (height != undefined ? height : "auto")};
`;

export const CardFilled = styled.div`
  padding: 21.3px 19.5px 31px 20px;
  border-radius: 6px;
  background-color: #f6f6f6;
`;

export const Card = styled.div`
  padding: 21px 19px 26.4px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
`;

export const Separator = styled.div`
  height: 0;
  margin: ${({ margin }) => (margin != undefined ? margin : "35px")} 0;
  border-top: 1px solid #b9b9ba;
`;

export const VerticalSeparator = styled.div`
  width: 0;
  height: 100%;
  margin: 0 ${({ margin }) => (margin != undefined ? margin : "50%")};
  border-left: 1px solid #b9b9ba;
`;

export const Text = styled.div`
  font-size: 12px;
  font-family: Roboto;
  font-weight: ${({ weight }) => weight || "500"};
  color: ${({ textColor }) => textColor || "#000"};
  text-align: ${({ align }) => align || "auto"};
`;

export const RodaPe = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const SelectPaginacaoWrapper = styled.div`
  width: 70%;
`;

export const SelectContainer = styled.div``;

export const ButtonWrapper = styled.div`
  ${({ margin = "1rem 0 0 1rem" }) => css`
    button {
      margin: ${margin};
    }
  `}

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardHeader = styled.div`
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px #bbbbbb;
  margin-top: 40px;

  ${({ theme }) => css`
    .border {
      padding: 10px;
      color: ${theme.colors.gray};
      font-size: 1.3rem;
      width: 37%;
      height: auto;
      text-align: center;
    }
  `}

  @media only screen and (max-width: 500px) {
    .border {
      padding: 0;
      text-align: center;
      width: 44%;
    }

    span {
      font-size: 1.2rem;
    }
  }

  @media (min-width: 1600px) {
    .border {
      width: 35%;
    }
  }
`;

export const PopupBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(36, 33, 33, 0.863);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const PopupContainer = styled.div`
  width: 70%;
  height: auto;
  border-radius: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 35px 50px 50px 50px;
`;

export const TitleCloseBtn = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    background-color: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 80%;
    display: flex;
    align-items: center;
    padding-bottom: 0.8rem;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const Image = styled.img`
  margin-right: 1.5rem;
  height: 4rem;

  @media (min-width: 1600px) {
    height: 4rem;
  }

  @media only screen and (max-width: 500px) {
    height: 2.8rem;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
    @media only screen and (max-width: 500px) {
      font-size: 1.4rem;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;

    @media only screen and (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span {
    font-family: Roboto;
    font-size: 12px;
    line-height: 1.17;
    text-align: left;
    color: #747576;
  }
`;
